module.exports = __webpack_public_path__ + "img/logo.b161b1e3.png";